<div libFocusTrap class="modal-wrapper">
    <div class="modal-content">
        @if (parameters?.title) {
            <div class="modal-header">
                <h2>{{ parameters?.title }}</h2>
                <div class="bar"></div>
                @if (!parameters?.hideCloseButton) {
                    <button class="close-wrapper" tabindex="0" (click)="close(false)" aria-label="Close modal">
                        <div class="icon" [innerHTML]="closeIcon"></div>
                    </button>
                }
            </div>
        }

        @if (!isContentArray) {
            <div class="modal-body">
                @if (parameters?.bodyTitle) {
                    <p class="title" [innerHTML]="$safeNavigationMigration(parameters?.bodyTitle)"></p>
                }
                <p [innerHtml]="parameters?.content ?? 'Cancel'"></p>
            </div>
        }
        @if (isContentArray) {
            @for (content of contentAsArray; track content) {
                <div class="modal-body">
                    <p [innerHtml]="content"></p>
                </div>
            }
        }

        <div class="modal-footer">
            @if (parameters?.cancelCaption) {
                <button class="modal-button cancel" (click)="close(false)" tabindex="0">
                    {{ parameters?.cancelCaption }}
                </button>
            }
            <button
                class="modal-button confirm"
                #acceptButton
                (click)="close(true)"
                tabindex="0"
                [ngClass]="{ reject: parameters?.isReject === true }"
            >
                {{ parameters?.acceptCaption || 'Accept' }}
            </button>
        </div>
    </div>
</div>
